(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name TransporteenvioController
* @description
* This is main controller
**/ 

    angular
    .module('appback')
    .controller('TransporteenvioController', TransporteenvioController);

    TransporteenvioController.$inject = ["TransportesService","GenerallabService","$timeout","$uibModal","$location",'$anchorScroll','$window'];

    function TransporteenvioController(TransportesService,GenerallabService,$timeout,$uibModal,$location,$anchorScroll,$window)
    {
    	////console.log("TransporteenvioController Enabled");
    	var vm = this;
    	vm.envio = { horarios : [{}] };
		vm.actualizar_envios = -1;

    	vm.popupTrans = "";
        vm.generalLab = GenerallabService;
		vm.popupNotes = false;

		vm.nuevo_envio = function(timestamp, pais_id){
			TransportesService.getNuevoEnvio(timestamp, pais_id, function(data){
				vm.actualizar_envios = data.nuevos_envios;
				console.log("count new envios: ", vm.actualizar_envios)
				$timeout(function(){
					vm.nuevo_envio(timestamp, pais_id);
				}, 20000);
			})



		}

		vm.reloadPage = function(){
			$window.location.reload()
		}

    	
    	vm.popup = function(centro_id,peticion_id,agencia_id){
    		//console.log("envio");
    		TransportesService.getCentroTransporte(centro_id,function(data){
               vm.popupTrans = $uibModal.open({
	              animation: true,
	              ariaLabelledBy: 'modal-title-top',
	              ariaDescribedBy: 'modal-body-top',
	              windowClass: 'show',
	              //backdrop  : 'static',
	              templateUrl: 'modalenvio.html',
	              size: 'lg',
	              controller: function($scope) {
	              	$scope.generalLab = GenerallabService;
	              	$scope.peticionesEncamino = data.peticionesEncamino;
	        		$scope.agenciaRecomendada = data.agenciaRecomendada;
	              	$scope.ultimoTrans = data.ultimoTrans;

	              	$scope.resetServicio = function(envio){
	              		//console.log("resetEnvio");
	              		envio.tipo_servicio = "";
	              	}

					

	              	$scope.code = 0;
	              	$scope.envio = data.centro;
	              	$scope.envio.peticion_id = peticion_id;
	              	$scope.envio.horarios = [{}];


	              	if(data.agenciaRecomendada.agencia){
	              		$scope.envio.agenciatransporte_id = data.agenciaRecomendada.agencia.id;
	              	}
	              	if(data.agenciaRecomendada.servicio){
	              		$scope.envio.tipo_servicio = data.agenciaRecomendada.servicio.id;
	              	}

	              	//console.log($scope.envio);
	                $scope.okForm = function(){
    					TransportesService.enviarTransporte($scope.envio,function(data){
    						if(data.tracking){
    							$scope.code = 1;
    						}else{
    							$scope.code = -1;
    						}
    						$scope.tracking = data.tracking;
    						$('tr.pet_'+data.envio.peticion_id).addClass("tachado");
    						$('tr.pet_'+data.envio.peticion_id).find('.trackingfield').html(data.tracking);
    						$('tr.pet_'+data.envio.peticion_id).removeClass("danger").removeClass("warning").addClass("success");
    						//console.log('tr.pet_'+data.envio.peticion_id);
    					});
	                }
	                $scope.koForm = function(){
	                    vm.popupTrans.close();
	                }
	                $scope.cambiarRecogida = function(type){
			    		//console.log(type);
			    		if(type==0){
			    			//CAMBIAMOS EL HORARIO DEFAULT MAÑANA
			    			$scope.envio.horarios[0].hora_desde = "10";
			    			$scope.envio.horarios[0].minutos_desde = "00";
			    			$scope.envio.horarios[0].hora_hasta = "13";
			    			$scope.envio.horarios[0].minutos_hasta = "00";
			    		}
			    		if(type==1){
			    			//CAMBIAMOS EL HORARIO DEFAULT MAÑANA
			    			$scope.envio.horarios[0].hora_desde = "17";
			    			$scope.envio.horarios[0].minutos_desde = "00";
			    			$scope.envio.horarios[0].hora_hasta = "20";
			    			$scope.envio.horarios[0].minutos_hasta = "00";
			    		}
			    		if(type==2){
			    			//CAMBIAMOS EL HORARIO DEFAULT MAÑANA
			    			$scope.envio.horarios[0].hora_desde = "10";
			    			$scope.envio.horarios[0].minutos_desde = "00";
			    			$scope.envio.horarios[0].hora_hasta = "20";
			    			$scope.envio.horarios[0].minutos_hasta = "00";
			    		}
			    		//console.log($scope.envio);
	                }
	              }
	            });
            });
    		
    	}
		vm.loadingPeti = [];
		vm.iaPrediction = function(peticion_id){
			vm.loadingPeti[peticion_id] = true;
			console.log("E");
			TransportesService.setIAPrediction(peticion_id).then(function(data){
				console.log("data", data);
				if(data.data.code==1){
					$('tr.pet_'+peticion_id).addClass("tachado");
					$('tr.pet_'+peticion_id).find('.trackingfield').html(data.data.tracking);
					$('tr.pet_'+peticion_id).removeClass("danger").removeClass("warning").addClass("success");
				}else{
					vm.loadingPeti[peticion_id] = false;
				}
				
            })
		}

    	vm.popupCentro = "";
    	vm.viewCentro = function(centro_id,peticion_id){
    		//console.log("envio");
    		TransportesService.getCentroTransporte(centro_id,function(data){
               vm.popupCentro = $uibModal.open({
	              animation: true,
	              ariaLabelledBy: 'modal-title-top',
	              ariaDescribedBy: 'modal-body-top',
	              windowClass: 'show',
	              //backdrop  : 'static',
	              templateUrl: 'modalcentro.html',
	              size: 'lg',
	              controller: function($scope) {
	              	$scope.envio = data.centro;
	              	$scope.envio.peticion_id = peticion_id;
	              	//console.log($scope.envio);
	                $scope.okForm = function(){
	                    vm.popupCentro.close();
    				
	                }
	                $scope.koForm = function(){
	                    vm.popupCentro.close();
	                }
	              }
	            });
            });
    		
    	}

		vm.viewNotes = function(centro_id,peticion_id){
			TransportesService.getNotesTransporte(centro_id,peticion_id,function(data){
				vm.popupNotes = $uibModal.open({
				   animation: true,
				   ariaLabelledBy: 'modal-title-top',
				   ariaDescribedBy: 'modal-body-top',
				   windowClass: 'show',
				   //backdrop  : 'static',
				   templateUrl: 'modalnotes.html',
				   size: 'lg',
				   controller: function($scope) {
					 $scope.code = data.code;
					 $scope.notas = data.notas;
					 $scope.nueva_nota = '';
					 $scope.setNota = function(nueva_nota){
						console.log("nueva nota: ", nueva_nota);
						if (nueva_nota) {
							TransportesService.setNota(nueva_nota, peticion_id, function(data){
								$scope.notas = data.notes;
							})
							$scope.nueva_nota = '';
						}
					 }
					 $scope.okForm = function(){
						 vm.popupNotes.close();
						 console.log("notas", $scope.notas);

					 
					 }
					 $scope.koForm = function(){
						 vm.popupNotes.close();
						 console.log("notas", $scope.notas);

					 }
				   }
				 });
				});
		}

    	
    	
        
    }
})();